import { render, staticRenderFns } from "./SmallForm.vue?vue&type=template&id=0fcf545c&scoped=true&"
import script from "./SmallForm.vue?vue&type=script&lang=js&"
export * from "./SmallForm.vue?vue&type=script&lang=js&"
import style0 from "./SmallForm.vue?vue&type=style&index=0&id=0fcf545c&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf545c",
  null
  
)

export default component.exports